// INDEXONE Landing Page - Copywriting & Content

export const SITE_CONFIG = {
  name: 'INDEXONE',
  tagline: 'Gestión Documental Inteligente',
  email: 'info@indexone.com.co',
  phone: '+57 (300) 602 6405',
  address: 'Villa Sandra Mz C Lt 7 Sector 1, Cartagena, Colombia',
};

export const NAVIGATION = [
  { label: 'Características', href: '#transformacion-digital' },
  { label: 'Normatividad', href: '#normatividad' },
  { label: 'Beneficios', href: '#beneficios' },
  { label: 'Contacto', href: '#contacto' },
];

export const HERO = {
  title: 'Desbloquea el verdadero poder de tus Documentos.',
  subtitle: 'Con Indexone integras inteligentemente los documentos en tus procesos críticos de negocio, con flujos de trabajo automatizados y correspondencia multicanal. Libera el máximo potencial de tu organización, con herramientas que generan valor de verdad.',
  ctaPrimary: 'Solicitar Demo',
  ctaSecondary: 'Ver Características',
  trustBadge: 'Software de Gestión Documental con cumplimiento normativo del AGN',
};

export const DIGITAL_TRANSFORMATION = {
  title: 'El Motor de la Transformación Digital',
  subtitle: 'Descubre cómo nuestras soluciones especializadas en Gestión Documental Electrónica, Flujos de Trabajo y Radicación de Correspondencia aseguran y agilizan el 100% de tu operación',
  blocks: [
    {
      id: 'block-1',
      title: 'Repositorio Documental Inteligente',
      subtitle: 'El corazón digital de tu organización',
      description: 'Transforma el almacenamiento físico y desorganizado en un archivo digital seguro, estructurado y de acceso inmediato. Encuentra el documento exacto en solo unos pocos segundos y cruza información sin depender de la memoria de tus colaboradores.',
      image: '/bloque-1.png',
      imageAlt: 'Repositorio Documental Inteligente - INDEXONE',
      layout: 'image-right', // Zig-zag pattern: first block image on right
    },
    {
      id: 'block-2',
      title: 'Flujos de Trabajo (Workflows)',
      subtitle: 'Acelera tu operación sin escribir código',
      description: 'Lleva la eficiencia de tu equipo al siguiente nivel transformando procesos manuales en rutas digitales estructuradas y dinámicas. Elimina los cuellos de botella y reduce drásticamente el uso de papel y los tiempos de gestión corporativa. Agiliza la toma de decisiones conectando directamente a las personas correctas y garantizando un control y trazabilidad absoluta sobre quién aprueba y cuáles son las responsabilidades en cada etapa de los procesos.',
      image: '/bloque-2.png',
      imageAlt: 'Flujos de Trabajo (Workflows) - INDEXONE',
      layout: 'image-left', // Zig-zag pattern: second block image on left
    },
    {
      id: 'block-3',
      title: 'Gestión de Correspondencia',
      subtitle: 'Control unificado de tus comunicaciones',
      description: 'Centraliza la entrada y salida de información oficial para que ninguna comunicación o requerimiento quede sin gestionar. Obtén control total sobre la radicación multicanal, distribución y seguimiento del flujo completo de tus comunicaciones de entrada y salida. Optimiza la atención en múltiples sedes institucionales y agiliza las respuestas a los clientes o entidades externas, aumentando la transparencia y blindando a tu organización frente a requerimientos legales.',
      image: '/bloque-3.png',
      imageAlt: 'Gestión de Correspondencia - INDEXONE',
      layout: 'image-right', // Zig-zag pattern: third block image on right
    },
  ],
};

export const AI_FEATURES = {
  title: 'El Poder de la Automatización',
  subtitle: 'Automatiza lo que antes tomaba horas. Deja que la tecnología trabaje por ti.',
  features: [
    {
      id: 'classification',
      icon: 'Inbox',
      title: 'Gestión de Bandejas de Correo',
      description: 'Deja de leer, clasificar y gestionar correos electrónicos manualmente. Nuestra motor de Integración de buzones lee, entiende y clasifica tus bandejas, disparando flujos de trabajo automáticamente.',
    },
    {
      id: 'semantic-search',
      icon: 'Search',
      title: 'Búsqueda de Texto Completo',
      description: 'Encuentra documentos como si usaras Google. No busques solo por metadatos, busca también por texto en el contenido de los documentos. "Contrato de arrendamiento" o "Evaluación de proveedores 2025".',
    },
    {
      id: 'ocr',
      icon: 'ScanText',
      title: 'Importación Masiva',
      description: 'Convierte imágenes y papel en datos organizados y buscables automáticamente. Digitaliza tu archivo histórico sin esfuerzo manual, aplicando técnicas de OCR a lotes masivos de documentos.',
    },
  ],
};

export const REGULATORY = {
  title: 'Tranquilidad Jurídica',
  subtitle: 'Cumplimiento normativo garantizado. Cero hallazgos en auditorías.',
  features: [
    {
      id: 'expediente',
      icon: 'Shield',
      title: 'Expediente Electrónico',
      description: 'Integridad, autenticidad y disponibilidad a largo plazo. Cada documento con trazabilidad completa y firma digital.',
    },
    {
      id: 'sgdea',
      icon: 'FileCheck',
      title: 'SGDEA Certificado',
      description: 'Cumplimiento total de tablas de retención documental (TRD) y normativa del Archivo General de la Nación.',
    },
    {
      id: 'ventanilla',
      icon: 'Inbox',
      title: 'Ventanilla Única',
      description: 'Gestión centralizada de correspondencia de entrada y salida. Radicación automática y seguimiento en tiempo real.',
    },
  ],
  certifications: [
    { name: 'Ley 594/2000', icon: 'shield-check' },
    { name: 'Ley 527/1999', icon: 'shield-check' },
    { name: 'Ley 1437/2011', icon: 'shield-check' },
    { name: 'Ley 1712/2014', icon: 'shield-check' },
    { name: 'Decreto 1080/2015', icon: 'lock' },
    { name: 'Acuerdo 001/2024', icon: 'lock' },
    { name: 'Dublin Core', icon: 'award' },
    { name: 'Moreq AGN', icon: 'award' },
  ],
};

export const HOW_IT_WORKS = {
  title: '¿Cómo Funciona?',
  subtitle: 'Tres pasos simples para transformar tu gestión documental',
  steps: [
    {
      step: '01',
      title: 'Captura Multi-Canal',
      description: 'Captura documentos desde email, escáner web, aplicaciones móviles o carga masiva. Todo se centraliza automáticamente.',
      icon: 'Upload',
    },
    {
      step: '02',
      title: 'Procesamiento Automático',
      description: 'La herramienta clasifica, extrae datos y enruta documentos según tus reglas de negocio. Sin intervención manual innecesaria.',
      icon: 'Cpu',
    },
    {
      step: '03',
      title: 'Consulta y Control',
      description: 'Acceso seguro desde cualquier lugar. Búsqueda instantánea, reportes automáticos y auditoría completa.',
      icon: 'LineChart',
    },
  ],
};

export const BENEFITS_TABS = {
  title: 'Beneficios para tu Organización',
  tabs: [
    {
      id: 'private',
      label: 'Sector Privado',
      title: 'Eficiencia y Reducción de Costos',
      benefits: [
        'Reducción de hasta 70% en costos operativos de archivo.',
        'Flujos de aprobación 5 veces más rápidos.',
        'Enrutamiento hacia oficina Cero Papel.',
        'Integración con ERP, CRM y otros sistemas mediante API.',
        'Recuperación de documentos en segundos.',
        'Trabajo remoto sin límites de acceso.',
      ],
      icon: 'Briefcase',
    },
    {
      id: 'public',
      label: 'Sector Público',
      title: 'Cumplimiento y Transparencia Garantizada',
      benefits: [
        'Cero hallazgos en auditorías del AGN atribuibles al SGDEA.',
        'Transparencia total con trazabilidad de cada acción.',
        'Reducción de +80% en tiempos de respuesta a peticiones.',
        'Cumplimiento automático de plazos según términos de Ley.',
        'Reportes de gestión para entes de control.',
        'Ventanilla única para atención ciudadana.',
      ],
      icon: 'Building',
    },
  ],
};

export const CTA_SECTION = {
  title: '¿Estás listo para Transformar tu Gestión Documental?',
  subtitle: 'Agenda una demo personalizada y descubre cómo INDEXONE puede revolucionar tus procesos de negocio.',
  ctaButton: 'Solicitar Demo Gratuita',
  guarantee: 'Sin compromiso. Demo personalizada en 30 minutos.',
};

export const FOOTER = {
  description: 'Plataforma Web de Gestión Documental.',
  columns: [
    {
      title: 'Producto',
      links: [
        { label: 'Características', href: '#transformacion-digital' },
        { label: 'Normatividad', href: '#normatividad' },
        { label: 'Beneficios', href: '#beneficios' },
        { label: 'Contacto', href: '#contacto' },
      ],
    },
    {
      title: 'Recursos',
      links: [
        { label: 'Documentación', href: '#docs' },
        { label: 'Centro de Ayuda', href: '#ayuda' },
        { label: 'Webinars', href: '#webinars' },
        { label: 'Blog', href: '#blog' },
      ],
    },
    {
      title: 'Legal',
      links: [
        { label: 'Términos y Condiciones', href: '#terminos' },
        { label: 'Política de Privacidad', href: '#privacidad' },
        { label: 'Tratamiento de Datos', href: '#datos' },
        { label: 'Certificaciones', href: '#certificaciones' },
      ],
    },
  ],
  copyright: '© 2026 INDEXONE. Todos los derechos reservados.',
};